<template> </template>

<script>
import { Base64 } from "js-base64";
import { obj2urlsp } from "utils";
export default {
  name: "accessLogin",
  data() {
    return {
      loginForm: {
        userName: "",
        passwd: ""
      },
      routerName: "",
      sendNew: []
    };
  },
  mounted() {
    this.confirmLogin();
  },
  methods: {
    confirmLogin() {
      this.loginForm.userName = Base64.decode(this.$route.query.key);
      this.loginForm.passwd = Base64.decode(this.$route.query.secret);
      this.routerName = this.$route.query.routerName;
      this.$axiospost(
        "auth/token/login",
        obj2urlsp({
          ...this.loginForm,
          type: 6
        })
      ).then(
        res => {
          if (res.data.status === 10000) {
            this.$axiosget(
              "manager/companySystem/findNewNameAndFlagByCompanyId/".concat(
                res.data.data.companyId
              )
            ).then(response => {
              let sendNew = response.data.data || [];
              localStorage.setItem("sendNew", JSON.stringify(sendNew));
              this.sendNew = sendNew;
            });
            sessionStorage.setItem("startSocket", true);
            this.$store.commit("SET_SOCKET", true);
            this.$store.commit("SET_USER", res.data.data.user);
            localStorage.setItem("companyId", res.data.data.companyId);
            localStorage.setItem("user", JSON.stringify(res.data.data.user));
            localStorage.setItem("username", res.data.data.user.username);
            localStorage.setItem("remmber", this.remmber);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("securityLevel", res.data.data.securityLevel);
            localStorage.setItem("userId", res.data.data.user.id);
            localStorage.setItem("userAccount", this.loginForm.userName);
            localStorage.setItem("title", res.data.data.user.title);
            localStorage.setItem("userphone", this.loginForm.userName);
            this.$store.dispatch("addRoutes").then(() => {
              if (this.routerName) {
                this.$router.push({
                  name: this.routerName
                });
              } else if (res.data.data.user.url == "home") {
                this.$router.push({
                  path: "/home"
                });
              } else {
                this.$router.push({
                  path: res.data.data.user.url
                });
              }
            });
          } else {
            this.$router.push("/login");
          }
        },
        e => {}
      );
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/password/accessLogin/accessLogin.vue